import { P2 } from '~/src/geometry/point';
import { comp , constant } from '~/src/base/Function';

import State, { ctrd , angle } from '../State';


export interface Rotate {
	tag : 'Rotate';
	set : boolean;
	val : number;
	pnt : P2;
}

export const rotate = ( val : number , pnt : P2 , set ?: boolean ) : Rotate =>
	( { tag : 'Rotate' , set : set ?? false , val , pnt } );

export const exeRotate = ( state : State , cmd : Rotate ) : State => comp(
	ctrd( constant( false ) ),
	angle( ang => cmd.set ? cmd.val : ang + cmd.val )
)( state );
